<template>
  <div class="modal" id="loadingModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="fa-3x">
              <i class="fas fa-circle-notch fa-spin"></i>
            </div>
            <p><b>Carregando...</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },

  watch: {
    loading (value) {
      if (value) {
        window.$('#loadingModal').modal('show')
      } else {
        window.$('#loadingModal').modal('hide')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoadingModal.vue